module.exports = __webpack_public_path__ + "img/IT.9810c0b7.webp";